import React, {useState, useEffect} from 'react';
import {
  BsTwitter,
  BsTelegram,
  BsLinkedin,
  BsReddit,
  BsFacebook,
} from 'react-icons/bs';
import {FaWhatsappSquare} from 'react-icons/fa';
import logo from '../../assets/logo.png';
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  RedditShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from 'react-share';

import {useSelector, useDispatch} from 'react-redux';

import Web3Modal from 'web3modal';
import {ethers} from 'ethers';
import {accountChange, connect, disconnect} from '../../redux/providerSlice';
import { notifyError } from '../../utils/toastError';
import axios from '../../utils/axios';
import { getAllSocialMedia } from '../../Services/AllSocialMedia';

const Header = () => {
  const [ status, setStatus ] = useState(true);
  const [ shareData, setShareData ] = useState({});

  const getLinkAndStatus = async () => {
    try{
      const response  = await getAllSocialMedia();
      const data = await response.data.allSocialMedia[0];
      setShareData(data);
      
    }catch(error){
      notifyError("Error while getting social media data");
      console.log(error)
    }
  }

  useEffect(()=>{
    getLinkAndStatus();
  },[]);

  const socialMediaStatus = async () => {
    try{
      const response = await axios.get(`api/socialMedia`,
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        }
      }
      );
      
      setStatus(response.data.socialMedia[0].status);
    }catch(error){
      console.log(error.message);
      notifyError('Error fetching social media status');
    }
  }

  useEffect(() => {
    socialMediaStatus();
  }
  , [])



  const login = useSelector (state => state.provider);
  const dispatch = useDispatch ();
  useEffect (() => {
    if(typeof window.ethereum !== 'undefined'){
      handleWallet ();
    }else{
      notifyError("Please Install MetaMask Wallet");
    }
  }, []);

  // console.log('login', login);
  const handleWallet = async () => {
    const instance = await web3Modal.connect ();
    const provider = new ethers.providers.Web3Provider (instance);
    const signer = provider.getSigner ();
    const address = await signer.getAddress();
    // console.log('address', address);
    dispatch (connect ({provider: provider, signer: signer, address: address}));
    if (instance) {
      // console.log ('object', instance);
    } else {
      // console.log ('no', instance);
    }

    // Subscribe to accounts change
    instance.on ('accountsChanged', accounts => {
      // console.log (accounts);
      if (accounts.length > 0) {
        dispatch (accountChange (accounts[0]));
      } else {
        dispatch (disconnect ());
      }
    });

    // Subscribe to chainId change
    instance.on ('chainChanged', chainId => {
      console.log (chainId);
    });

    // Subscribe to instance connection
    instance.on ('connect', info => {
      console.log (info);
    });

    // Subscribe to instance disconnection
    instance.on ('disconnect', error => {
      console.log (error);
    });
  };
  
  const providerOptions = {
    /* See Provider Options Section */
    injected: {
      display: {
        logo: 'data:image/gif;base64,INSERT_BASE64_STRING',
        name: 'Injected',
        description: 'Connect with the provider in your Browser',
      },
      package: null,
    },
  };

  const web3Modal = new Web3Modal ({
    providerOptions,
  });

  // console.log('shareData', shareData?.facebook?.status);
  return (
    <header className="top-0   py-4 px-5 md:px-10 w-full">
      <nav className="grid grid-cols-2 md:grid-cols-3">
        <div className="flex items-center ">
          <img src={logo} alt="logo" className="w-20 h-13 cursor-pointer" />
        </div>

        {status ? (<div className="hidden md:flex items-center justify-between px-[2.5em]">

        {shareData?.facebook?.status ? (
          <a 
            href={shareData?.facebook?.link}
            target="_blank"
            rel="noreferrer"
          >
            <BsFacebook className="text-lyellow text-2xl cursor-pointer" />
          </a>
        ): null  }
          
        
          {shareData?.twitter?.status ? (
            <a href={shareData?.twitter?.link}
            target="_blank"
            rel="noreferrer"
          >
            <BsTwitter className="text-lyellow text-2xl cursor-pointer" />
          </a>
          ) : null}
          
          {shareData?.telegram?.status ? (
            <a href={shareData?.telegram?.link}
            target="_blank"
            rel="noreferrer"
          >
            <BsTelegram className="text-lyellow text-2xl cursor-pointer" />
          </a>
          ): null }
          
          {shareData?.reddit?.status ? (
            <a href={shareData?.reddit?.link}
            target="_blank"
            rel="noreferrer"
          >
            <BsReddit className="text-lyellow text-2xl cursor-pointer" />
          </a>
          ): null}
          
          {shareData?.linkedIn?.status ? (
            <a href={shareData?.linkedIn?.link}
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin className="text-lyellow text-2xl cursor-pointer" />
          </a>
          ): null}
          

          {shareData?.whatsapp?.status ? (
            <a href={shareData?.whatsapp?.link}
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsappSquare className="text-lyellow text-3xl cursor-pointer" />
          </a>
          ): null}
          
        </div>) : (<>
          <div className="flex items-center justify-center mr-20">
            <h1 className="text-lyellow font-extrabold tracking-wide text-4xl">Grab A Bag</h1>
          </div>
        </>)  }
        

        <div className="flex items-center justify-end">

          {!login.connect
            ? <div>
                <button
                  className="bg-lyellow text-md font-semibold py-2 px-[3.6em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-200 rounded-xl"
                  onClick={handleWallet}
                >
                  Connect
                </button>
              </div>
            : <button className="bg-lyellow text-md font-semibold py-2 px-[3.6em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-200 rounded-xl">
                {login.accountAddress.substring (0, 6)}
                ...
                {/* {login.accountAddress} */}
                
                {login.accountAddress.substring (login.accountAddress.length - 4, login.accountAddress.length)}
              </button>}
          {/* <ConnectButton moralisAuth={false} /> */}
        </div>
      </nav>
    </header>
  );
};

export default Header;
